import {
  MARKER_CLUSTER_DEFAULTS,
  type MarkerClusterIconStyle,
  type MarkerClusterOptions,
} from '@gpx-spa/geo-domain'

export type ResolvedMarkerClusterSettings = {
  radius: number
  maxZoom: number
  icon: MarkerClusterIconStyle
  showCoverageOnHover: boolean
}

export function resolveMarkerClusterSettings(
  opts?: MarkerClusterOptions
): ResolvedMarkerClusterSettings {
  return {
    radius:
      opts?.radius ??
      opts?.clusterRadius ??
      opts?.maxClusterRadius ??
      MARKER_CLUSTER_DEFAULTS.radius,
    maxZoom:
      opts?.maxZoom ?? opts?.clusterMaxZoom ?? MARKER_CLUSTER_DEFAULTS.maxZoom,
    icon: opts?.icon ?? MARKER_CLUSTER_DEFAULTS.icon,
    showCoverageOnHover: opts?.showCoverageOnHover ?? false,
  }
}
